import { defineStore } from 'pinia';
import type { NewFlightSchoolAdministrator } from '@/types/FlightSchoolAdmin';

export const useAdminStore = defineStore({
    id: 'adminStore',
    state: () => ({
        admins: [{
            id: crypto.randomUUID(),
            email: '',
            emailSubscriber: false,
            valid: false,
        }] as NewFlightSchoolAdministrator[],
    }),
    actions: {
        generateId(): string {
            return crypto.randomUUID();
        },
        addAdmin(admin: Omit<NewFlightSchoolAdministrator, 'id'>) {
            this.admins.push({ id: this.generateId(), ...admin });
        },
        removeAdminById(adminId: string) {
            this.admins = this.admins.filter((a: NewFlightSchoolAdministrator) => a.id !== adminId);
        },
        updateAdmin(admin: NewFlightSchoolAdministrator) {
            this.admins = this.admins.map((a: NewFlightSchoolAdministrator) => {
                if (a.id === admin.id) {
                    return admin;
                }
                return a;
            });
        },
        isDuplicate(id: string, email: string): boolean {
            return this.admins.some((a: NewFlightSchoolAdministrator) => a.id !== id && a.email === email);
        },
        resetAdmins() {
            this.admins = [{
                id: this.generateId(),
                email: '',
                emailSubscriber: false,
                valid: false,
            }];
        },
    },
});
